export default "__VITE_ASSET__CrdDwZ$0__"